import ReactFlow, {
  Background,
  ConnectionMode,
  ReactFlowProvider,
  getNodesBounds,
  useEdgesState,
  useNodesState,
  type Edge,
  type Node,
  Viewport,
  ReactFlowInstance,
} from "reactflow";

import ZoomFlow from "../../../../../componentes/easyMaps/ZoomFlow";
import { Box, lighten, Stack, useTheme } from "@mui/material";
import ElementNode from "../../../../../componentes/easyMaps/elementNode";
import PositionableEdge from "../../../../../componentes/easyMaps/positionableEdge";
import {
  useEffect,
  useMemo,
  useRef,
  useState,
  type Dispatch,
  type MouseEvent as ReactMouseEvent,
  type SetStateAction,
} from "react";

import FilterElements from "../../../../../componentes/easyMaps/filterElements";
import TitleBarPublic_ from "../../../../../componentes/easyMaps/titleBarPublic";
import DescriptionBar_ from "../../../../../componentes/easyMaps/descriptionBar";
import RightBarEasyMaps_ from "../../../../../componentes/easyMaps/rightBarEasyMaps";
import { useOutletContext, useParams } from "react-router-dom";
import ToolBarMapsPublic_ from "../../../../../componentes/easyMaps/toolbarMapsPublic";
import LayerBar_ from "../../../../../componentes/easyMaps/layerBar";
import { useMapa } from "../../../../../contexts/mapaContext";
import { network } from "../../../../../schemas/elements";

interface IMapConnection extends network.monitor.IConnection {
  config?: ConnectionConfig;
  entangled?: boolean;
  destinationId?: string;
  referenceId?: string;
  [key: string]: unknown;
}

interface ReactFlowMapasProps {
  setEdgeSelected: Dispatch<SetStateAction<any>>;
  setElementsConnected: Dispatch<SetStateAction<any[] | null>>;
  iconsElements: MapImage[];
  setOpenRightBar: Dispatch<SetStateAction<boolean>>;
  focusNodeId: string | null;
  fullScreem: boolean;
  setFullScreem: (param: boolean) => void;
  title: string | undefined;
  setCoordenadasFlow?: (coords: { x: number; y: number }) => void;
  setIconsElements?: Dispatch<SetStateAction<MapImage[]>>;
  edgeSelected: any;
  openRightBar: boolean;
  setFocusNodeId: Dispatch<SetStateAction<string | null>>;
  setEasyMapsConfig?: (config: any) => void;
  easyMapsConfig?: any;
  collapse?: boolean;
  xyZoomFromUrl: { x: number; y: number; zoom: number };
  [key: string]: unknown;
}

const nodeTypes = {
  element: ElementNode,
};
const edgeTypes = {
  positionableedge: PositionableEdge,
};

const TitleBarPublic = TitleBarPublic_ as any;
const ToolBarMapsPublic = ToolBarMapsPublic_ as any;
const RightBarEasyMaps = RightBarEasyMaps_ as any;
const LayerBar = LayerBar_ as any;
const DescriptionBar = DescriptionBar_ as any;

const ReactFlowMapas = (props: ReactFlowMapasProps) => {
  const {
    setEdgeSelected,
    setElementsConnected,
    iconsElements,
    setOpenRightBar,
    focusNodeId,
    fullScreem,
    setFullScreem,
    title,
    setCoordenadasFlow = () => {},
    setIconsElements,
    edgeSelected,
    openRightBar,
    setFocusNodeId,
    setEasyMapsConfig = () => {},
    easyMapsConfig,
    xyZoomFromUrl,
  } = props;
  const {
    mapId,
    elements,
    connections,
    connectionsDataMap,
    elementSelected,
    setElementSelected,
    connectionSelected,
    setConnectionSelected,
    configElementDataMap,
    configurationMap,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
    alertsDataMap,
  } = useMapa();

  const urlValid =
    !Number.isNaN(xyZoomFromUrl.x) &&
    !Number.isNaN(xyZoomFromUrl.y) &&
    !Number.isNaN(xyZoomFromUrl.zoom);

  const initialViewport = useMemo(
    () =>
      urlValid
        ? { x: xyZoomFromUrl.x, y: xyZoomFromUrl.y, zoom: xyZoomFromUrl.zoom }
        : undefined,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const moveTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const updateUrl = (viewport: { x: number; y: number; zoom: number }) => {
    if (moveTimeout.current) clearTimeout(moveTimeout.current);
    moveTimeout.current = setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.set("x", String(viewport.x));
      url.searchParams.set("y", String(viewport.y));
      url.searchParams.set("zoom", String(viewport.zoom));
      window.history.replaceState({}, "", url);
    }, 200);
  };

  const [nodes, setNodes, onNodesChange] = useNodesState<MapElement>([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState<IMapConnection>([]);
  const bounds = getNodesBounds(nodes.filter((node) => !!node?.id));
  const [lockMode] = useState<boolean>(false);
  const [showLabel, setShowLabel] = useState<boolean>(true);
  const [elementsFilter, setElementsFilter] = useState<
    { nome: string; tipo: number }[]
  >([]);
  const [openConnection, setOpenConnection] = useState<string | null>(null);
  const [showLabelEnlace, setShowLabelEnlace] = useState<boolean>(true);
  // pega os elementos e conexões do Map
  const elementsFromMap = useMemo<MapElement[]>(
    () => Array.from(elements?.values() || []),
    [elements],
  );
  const connectionsFromMap = useMemo<IMapConnection[]>(
    () => Array.from(connections?.values() || []),
    [connections],
  );
  const ref = useRef<HTMLDivElement>(null);
  const { id, token } = useParams<{ id: string; token: string }>();
  const { configLayer } = useOutletContext<EasyMapsPublicLayoutContext>();
  const theme = useTheme();
  const modeDark = theme.palette.mode === "dark";

  useEffect(() => {
    const style = document.createElement("style");
    const enlaces = (theme.palette as any).enlaces;
    style.innerHTML = `
    @keyframes edgePulse {
      0% { stroke: ${enlaces?.offline?.main}; }
      50% { stroke: ${enlaces?.p90?.main}; }
      100% { stroke: ${enlaces?.offline?.main}; }
    }
    .edge-pulse {
      animation: edgePulse 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
    }
    @keyframes dashdrawEnlace {
      from { stroke-dashoffset: var(--dash-period, 10); }
      to { stroke-dashoffset: 0; }
    }
  `;
    document.head.appendChild(style);
    return () => {
      style.remove();
    };
  }, [theme]);

  const styles = {
    stackContainer: {
      position: fullScreem ? "fixed" : "relative",
      top: 0,
      left: 0,
      width: fullScreem ? "100vw" : "100%",
      height: fullScreem ? "100vh" : "100%",
      zIndex: fullScreem ? 1202 : 0,
      background:
        theme.palette.mode == "dark"
          ? theme.palette.background.default
          : lighten(theme.palette.background.default, 0.6),
      overflow: "visible",
    },
  } as const;

  const filteredData = useMemo<{
    nodes: MapElement[];
    edges: IMapConnection[];
  }>(() => {
    if (!configurationMap || !configLayer) {
      return { nodes: elementsFromMap, edges: connectionsFromMap };
    }
    const isPotencia = configLayer?.[String(mapId)] === "potencia";
    const filtros =
      configurationMap?.configuracoes?.[
        isPotencia ? "camadaPotencia" : "camadaTrafego"
      ]?.filtros;
    if (!filtros || filtros.length === 0) {
      return { nodes: elementsFromMap, edges: connectionsFromMap };
    }

    const dataMap = isPotencia
      ? connectionsDataMapPercentPower
      : connectionsDataMapPercentTraffic;

    // Gera um Set com todos os IDs de conexões filtradas (evita includes O(n))
    const enlacesSelected = new Set<string>(
      filtros?.flatMap((label: string) => dataMap.get(label) || []),
    );
    //filtras as conexões com base nos filtros
    const enlacesFiltered = connectionsFromMap.filter((conn) =>
      enlacesSelected.has(conn.id),
    );

    // Filtra conexões relevantes e extrai IDs únicos de markers
    const markersSelectedId = new Set<string>(
      connectionsFromMap?.flatMap((conn) =>
        enlacesSelected.has(conn.id)
          ? [conn.destinationId ?? "", conn.referenceId ?? ""]
          : [],
      ),
    );
    // Retorna apenas markers com ID presente
    const filtered = elementsFromMap.filter((m) => markersSelectedId.has(m.id));

    return { nodes: filtered, edges: enlacesFiltered };
  }, [
    configurationMap,
    configLayer,
    mapId,
    elementsFromMap,
    connectionsFromMap,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
  ]);

  useEffect(() => {
    setCoordenadasFlow({
      x: bounds?.x + bounds?.width / 2,
      y: bounds?.y + bounds?.height / 2,
    });
  }, [nodes]);

  useEffect(() => {
    setConnectionSelected(null);
    setElementsConnected(null);
    setNodes(
      handleFormaterNodes(structuredClone(filteredData?.nodes), showLabel),
    );
    setEdges(
      handleFormaterEdges(structuredClone(filteredData?.edges), showLabel),
    );
  }, [
    configLayer,
    showLabel,
    showLabelEnlace,
    elementsFilter,
    configurationMap,
  ]);

  useEffect(() => {
    if (!filteredData?.nodes && !filteredData?.edges) return;

    let formaterElements: MapElement[] = structuredClone(filteredData?.nodes);
    if (elementSelected) {
      formaterElements = [
        ...filteredData?.nodes.filter((ele) => ele?.id !== elementSelected?.id),
        elementSelected,
      ];
    }
    let formaterConnections: IMapConnection[] = structuredClone(
      filteredData?.edges,
    );
    if (connectionSelected) {
      formaterConnections = [
        ...filteredData?.edges.filter(
          (conn) => conn?.id !== connectionSelected?.id,
        ),
        {
          ...connectionSelected,
          positionHandlers: edgeSelected?.data?.positionHandlers,
        },
      ];
    }
    setNodes(handleFormaterNodes(formaterElements, showLabel));
    setEdges(handleFormaterEdges(formaterConnections, showLabel));
  }, [filteredData?.nodes, filteredData?.edges, connectionsDataMap]);

  //-----funcoes para formatação de dados
  const handleFormaterNodes = (
    elementsArr: MapElement[],
    showLabelArg: boolean = true,
    entangled: boolean = true,
  ): Node[] => {
    const filter = elementsFilter.map((value) => value.tipo);
    const newElements =
      elementsFilter.length > 0
        ? elementsArr.filter(({ tipo }) =>
            filter.includes(tipo as unknown as number),
          )
        : elementsArr;

    const result: Node[] = newElements.map((element) => {
      const {
        id: elId,
        elementConfig,
        titulo,
        img,
        tipo,
      } = element as MapElement & {
        img?: string;
        tipo?: number;
      };

      const rawViewType = element?.elementConfig?.config?.viewType;
      const descricao = elementConfig?.config?.descricao;

      const resolvedViewType =
        !rawViewType || rawViewType === "automatic"
          ? configurationMap?.configuracoes?.viewType || "compact"
          : rawViewType;

      const rawNodeSize = element?.elementConfig?.config?.nodeSize;
      const resolvedNodeSize =
        !rawNodeSize || Number(rawNodeSize) === 0
          ? configurationMap?.configuracoes?.nodeSize || 0
          : rawNodeSize;

      return {
        id: elId,
        type: "element",
        draggable: !!(elementSelected && elementSelected?.id == elId),
        position: {
          x: parseFloat(String(elementConfig?.config?.coordenadas?.long ?? 0)),
          y: parseFloat(String(elementConfig?.config?.coordenadas?.lat ?? 0)),
        },
        selected: elementSelected?.id === elId,
        data: {
          configElement: configElementDataMap.get(elId),
          img:
            iconsElements?.find((icon) => icon.id == img)?.img ||
            iconsElements?.find(
              (icon) =>
                icon.nome ==
                (tipo === 0 ? "_roteador" : tipo === 1 ? "_mapa" : "_pop"),
            )?.img,

          editMode: false,
          showLabel: showLabelArg,
          entangled,
          title: titulo,
          hosts: elementConfig?.config?.hosts,
          tipoMapa: 1,
          alerts: alertsDataMap.get(elId) || [],
          easyMapsConfig: structuredClone(configurationMap),
          viewType: resolvedViewType,
          size: resolvedNodeSize,
          descricao: descricao,
          value: 123,
        },
      };
    });
    return result;
  };
  const handleFormaterEdges = (
    conections: IMapConnection[],
    showLabelArg: boolean = true,
    entangled: boolean = true,
  ): Edge[] => {
    const result: Edge[] = conections.map((connection) => {
      const {
        id: connId,
        referenceId,
        destinationId,
        positionHandlers,
        config,
      } = connection;
      const data = (connection as { data?: unknown }).data;
      const dataConn = structuredClone(connectionsDataMap.get(connId));

      const rawViewType = config?.viewType;
      const resolvedViewType =
        !rawViewType || rawViewType === "automatic"
          ? configurationMap?.configuracoes?.viewType || "compact"
          : rawViewType;

      const rawEdgeLabelSize = config?.edgeLabelSize;
      const resolvedEdgeLabelSize =
        !rawEdgeLabelSize || rawEdgeLabelSize === 0
          ? configurationMap?.configuracoes?.edgeLabelSize || 0
          : rawEdgeLabelSize;
      return {
        id: connId,
        source: referenceId ?? "",
        type: "positionableedge",
        sourceHandle: config?.sourceHandle,
        targetHandle: config?.targetHandle,
        target: destinationId ?? "",
        animated: config?.animation !== "desativada" && !dataConn?.isDown,
        updatable: "target",
        markerEnd: undefined,
        labelStyle: { fill: "#26721f", fontWeight: 700 },
        selected: connectionSelected?.id === connId,
        data: {
          ...(dataConn ?? {}),
          host: elements?.get(referenceId ?? "")?.titulo,
          mapId: mapId,
          itensData: data,
          editMode: false,
          showLabel: showLabelArg,
          variant: configLayer?.[String(mapId)] || "trafego",
          showLabelEnlace,
          entangled,
          lineType: config?.type,
          viewType: resolvedViewType,
          edgeLabelSize: resolvedEdgeLabelSize,
          capacidade: config?.capacidade,
          positionHandlers: structuredClone(positionHandlers ?? []),
          //perigo eminente, sob hipótese nenhuma mexa nessa linha de código!
          label: "999.99Mbps",
          animation: config?.animation,
          easyMapsConfig: structuredClone(configurationMap),
          configLine: config,
          descriptionAsLabel: config?.descriptionAsLabel,
          interfaceDescription: config?.interfaceDescription,
        },
      };
    });
    return result;
  };

  const updateMemberStatus = (
    items: any[],
    ids: string[],
    updateData: (isMember: boolean) => Record<string, unknown>,
  ) => {
    return items.map((item) => ({
      ...item,
      data: {
        ...item.data,
        ...updateData(ids.includes(item.id)),
      },
    }));
  };

  const onNodeClick = (_event: ReactMouseEvent, node: Node<MapElement>) => {
    setConnectionSelected(null);
    setOpenConnection(null);
    setEdgeSelected(null);
    const selected = structuredClone(elements?.get(node.id));
    if (selected?.id === elementSelected?.id) {
      setElementSelected(null);
      return;
    }
    setElementSelected(selected);

    let idsElements: string[] = [selected.id];
    let idsConnections: string[] = [];
    let elementsConnect: MapElement[] = [];

    filteredData?.edges.forEach(({ referenceId, destinationId, id }) => {
      if (node.id === destinationId || node?.id === referenceId) {
        const findElement = elements?.get(
          (node.id === destinationId ? referenceId : destinationId) ?? "",
        );
        if (findElement) {
          elementsConnect.push(findElement);
          idsElements.push(findElement?.id);
        }
        idsConnections.push(id);
      }
    });
    setElementsConnected(elementsConnect);

    const updateEntangled = (isEntangled: boolean) => ({
      entangled: isEntangled,
    });

    setNodes((nds) => updateMemberStatus(nds, idsElements, updateEntangled));
    setEdges((eds) => updateMemberStatus(eds, idsConnections, updateEntangled));
    setOpenRightBar(true);
    return;
  };

  const onEdgeClick = (_event: ReactMouseEvent, edge: Edge<any>) => {
    setElementSelected(null);
    const selected = connections?.get(edge.id);
    setConnectionSelected(selected);
    setElementSelected(elements?.get(selected?.referenceId ?? ""));
    setOpenConnection(selected?.id ?? null);
  };

  const onPaneClick = () => {
    setConnectionSelected(null);
    setOpenConnection(null);
    setEdgeSelected(null);
    setNodes(handleFormaterNodes(filteredData?.nodes, showLabel));
    setEdges(handleFormaterEdges(filteredData?.edges, showLabel));
    setElementsConnected(null);

    if (elementSelected || edgeSelected) {
      setEdgeSelected(null);
      setConnectionSelected(null);
      setElementSelected(null);
    }
  };

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1203 }}>
        <TitleBarPublic
          title={title}
          center={elementSelected != null || connectionSelected != null}
        />
      </Box>
      <Stack sx={styles.stackContainer}>
        <ReactFlowProvider>
          <ToolBarMapsPublic
            setEasyMapsConfig={setEasyMapsConfig}
            easyMapsConfig={structuredClone(easyMapsConfig)}
            fullScreem={fullScreem}
            setFullScreem={setFullScreem}
            showLabel={showLabel}
            setShowLabel={setShowLabel}
            setShowLabelEnlace={setShowLabelEnlace}
            showLabelEnlace={showLabelEnlace}
            tipo={1}
          >
            <ToolBarMapsPublic.InputZoomTop />
          </ToolBarMapsPublic>
          <LayerBar elementSelected={elementSelected} mapId={mapId} />
          <DescriptionBar
            elementSelected={!!elementSelected}
            key={"descrptionbar"}
            variant="default"
            layer={configLayer?.[String(mapId)] || "trafego"}
          />
          <FilterElements
            iconsElement={iconsElements}
            elementsFilter={elementsFilter}
            setElementsFilter={setElementsFilter}
          />
          <ZoomFlow
            id={id}
            focusNodeId={focusNodeId}
            setFocusNodeId={setFocusNodeId}
            skipInitialFitView={urlValid}
          />
          <ReactFlow
            ref={ref}
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            snapToGrid={false}
            onPaneClick={onPaneClick}
            elementsSelectable={!lockMode}
            nodesConnectable={false}
            nodesDraggable={false}
            attributionPosition="bottom-left"
            fitView={!urlValid}
            defaultViewport={initialViewport}
            onMove={(_: any, viewport: Viewport) => updateUrl(viewport)}
            onInit={(instance: ReactFlowInstance) =>
              updateUrl(instance.getViewport())
            }
            connectionMode={ConnectionMode.Loose}
            onNodeClick={onNodeClick}
            onEdgeClick={onEdgeClick}
            minZoom={0.5}
            maxZoom={3}
            proOptions={{ hideAttribution: true }}
            style={{ background: modeDark ? "#141617" : "#e9ebee" }}
          >
            <Background />
          </ReactFlow>{" "}
          <RightBarEasyMaps
            mapId={mapId}
            setIconsElements={setIconsElements}
            connectionsFull={connections}
            setFocusNodeId={setFocusNodeId}
            open={openRightBar}
            setOpen={setOpenRightBar}
            elements={elements}
            connections={connections}
            setElement={setElementSelected}
            setConnections={setElementsConnected}
            iconsElement={iconsElements}
            element={elementSelected?.id ? elementSelected : null}
            fullScreem={fullScreem}
            openConnection={openConnection}
            setOpenConnection={setOpenConnection}
            link={`/easyMaps/mapa/public/${
              elementSelected?.mapRef?.tipo === 0 ? "geo" : "top"
            }/${elementSelected?.mapRefId ?? ""}/${token}`}
          />
        </ReactFlowProvider>{" "}
      </Stack>{" "}
    </>
  );
};
export default ReactFlowMapas;
